import About from "../Pages/About";
import Services from "../Pages/Service";

export const privateRoutes = [
  { path: "/about", name: "About", Component: About },
  { path: "/services", name: "Services", Component: Services },
];

